module.exports = __webpack_public_path__ + "img/layout-alt-03.fa713271.svg";